import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/scss/tailwind.scss'
import "@/assets/libs/@mdi/font/css/materialdesignicons.min.css";
import '@/assets/libs/@iconscout/unicons/css/line.css'
import router from './router';
import './plugins/axios'

import { WagmiPlugin } from '@wagmi/vue'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { wagmiAdapter } from './plugins/wagmi/config';

import { createPinia } from 'pinia';
import { useExplorerStore } from './store/ExplorerStore';
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const queryClient = new QueryClient();
const pinia = createPinia();

const vuetify = createVuetify({
  components,
  directives,
})

const app = createApp(App)
app.use(router);
app.use(vuetify)
app.use(WagmiPlugin, { config: wagmiAdapter.wagmiConfig })
app.use(VueQueryPlugin, { queryClient })
app.use(pinia)

const explorerStore = useExplorerStore();
explorerStore.initStore();


app.mount('#app')